import React, { useEffect, useState } from "react";
import Pagination from "@mui/material/Pagination";
import { Box, Stack, Typography } from "@mui/material";

import { exerciseOptions, fetchData } from "../utils/fetchData";
import ExerciseCard from "./ExerciseCard";
import Loader from "./Loader";

const Exercises = ({ exercises, setExercises, bodyPart }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [exercisesPerPage] = useState(6);

  useEffect(() => {  
    const fetchExercisesData = async () => {
      let exercisesData = [];

      if (bodyPart === "all") {
        const resp = await fetchData(
          // "https://exercisedb.p.rapidapi.com/exercises",
          "https://gymexercisesservices.onrender.com/exercises",
          exerciseOptions
        );
        // const resp = await data.json();
        // console.log(resp);
        exercisesData = resp;
        // exercisesData = exercisesData.json();
      } else {
        const resp = await fetchData(
          // `https://exercisedb.p.rapidapi.com/exercises/bodyPart/${bodyPart}`,
          // `http://localhost:3004/exercises?q=${bodyPart}`,
          `https://gymexercisesservices.onrender.com/search/${bodyPart}`,
          exerciseOptions
        );
        // const resp = await data.json();
        exercisesData = resp;
        // exercisesData = exercisesData.json();
      }
      console.log(exercisesData);
      setExercises(exercisesData);
    };

    fetchExercisesData();
  }, [bodyPart]);

  // Pagination
  const indexOfLastExercise = currentPage * exercisesPerPage;
  const indexOfFirstExercise = indexOfLastExercise - exercisesPerPage;
  const currentExercises = exercises.slice(
    indexOfFirstExercise,
    indexOfLastExercise
  );

  const paginate = (event, value) => {
    setCurrentPage(value);

    window.scrollTo({ top: 1800, behavior: "smooth" });
  };

  if (!currentExercises.length) return <Loader />;

  return (
    <Box id="exercises" sx={{ mt: { lg: "109px" } }} mt="50px" p="20px">
      <Typography
        variant="h4"
        fontWeight="bold"
        sx={{ fontSize: { lg: "44px", xs: "30px" } }}
        mb="46px"
      >
        <span style={{ color: '#FF2625' }}>{exercises.length}</span>  Showing Results 
      </Typography>
      <Stack
        direction="row"
        sx={{ gap: { lg: "107px", xs: "50px" } }}
        flexWrap="wrap"
        justifyContent="center"
      >
        {currentExercises.map((exercise, idx) => (
          <ExerciseCard key={idx} exercise={exercise} />
        ))}
      </Stack>
      <Stack sx={{ mt: { lg: "114px", xs: "70px" } }} alignItems="center">
        {exercises.length > 9 && (
          <Pagination
            color="standard"
            shape="rounded"
            defaultPage={1}
            count={Math.ceil(exercises.length / exercisesPerPage)}
            page={currentPage}
            onChange={paginate}
            size="large"
          />
        )}
      </Stack>
    </Box>
  );
};

export default Exercises;
